import { render, staticRenderFns } from "./FeCorporacion.vue?vue&type=template&id=80ef1fd6&"
import script from "./FeCorporacion.vue?vue&type=script&lang=js&"
export * from "./FeCorporacion.vue?vue&type=script&lang=js&"
import style0 from "./FeCorporacion.vue?vue&type=style&index=0&id=80ef1fd6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports